export default __webpack_public_path__ + "static/media/profile.ae3a914b.png";